/**
 * User Role Constants
 * These match the UserRole enum in the backend Prisma schema
 */

export const USER_ROLES = {
  USER: 'USER',
  ADMIN: 'ADMIN',
  DEVELOPER: 'DEVELOPER',
  CUSTOMER: 'CUSTOMER',
} as const;

export type UserRoleType = typeof USER_ROLES[keyof typeof USER_ROLES];

export interface RoleOption {
  value: string;
  label: string;
  color: string;
  description?: string;
}

export const ROLE_OPTIONS: RoleOption[] = [
  { 
    value: USER_ROLES.USER, 
    label: 'User', 
    color: 'blue',
    description: 'Standard user with basic permissions'
  },
  { 
    value: USER_ROLES.ADMIN, 
    label: 'Admin', 
    color: 'purple',
    description: 'Administrator with elevated permissions'
  },
  {
    value: USER_ROLES.DEVELOPER,
    label: 'Developer',
    color: 'purple',
    description: 'Developer with admin-level access except global role management'
  },
  { 
    value: USER_ROLES.CUSTOMER, 
    label: 'Customer', 
    color: 'green',
    description: 'Customer user with customer-specific permissions'
  },
];

/**
 * Get role option by value
 */
export const getRoleOption = (role: string): RoleOption | undefined => {
  return ROLE_OPTIONS.find(opt => opt.value === role);
};

/**
 * Get role color by value
 */
export const getRoleColor = (role: string): string => {
  return getRoleOption(role)?.color || 'default';
};

/**
 * Get role label by value
 */
export const getRoleLabel = (role: string): string => {
  return getRoleOption(role)?.label || role;
};

